export enum DateFormats {
  Date = 'date',
  Time = 'time',
  DateTime = 'dateTime',
}
